var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumablesHowItWorksStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "url(#paint0_linear_2430_205234)",
    strokeOpacity: 0.2,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.1374 11.5455V29H19.4471V15.0483H19.3448L15.3477 17.554V14.2812L19.6687 11.5455H23.1374Z",
    fill: "url(#paint1_linear_2430_205234)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2430_205234",
    x1: -0.00000670511,
    y1: 39.9999,
    x2: 42.8553,
    y2: 36.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2430_205234",
    x1: -0.00000670511,
    y1: 33.9999,
    x2: 42.588,
    y2: 29.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumablesHowItWorksStep1);
export default __webpack_public_path__ + "static/media/consumables_how_it_works_step_1.4d4b902adeef1e43b2d2b3818afc1dc1.svg";
export { ForwardRef as ReactComponent };